import React, {useRef, useState} from "react";
import {validateMode} from "root/Modals/modalFunctions";
import Modal from "react-responsive-modal";
import ModalLunchReport from "root/s360components/Modals/LunchReport/ModalLunchReport";
import {ModalLunchReportModes} from "root/s360components/Modals/LunchReport/useModalLunchReport";
import ModalMisWritebackInfo from "root/s360components/Modals/MisWritebackInfo/ModalMisWritebackInfo";

export const ModalMisWritebackInfoModes = {
    VIEW: 'view'
}

const useModalMisWritebackInfo = () =>
{

    const defaultState =  { openState: false, mode: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    //Success of submission
    const resolvePromise = useRef(null);

    const onClickActivate = ( { mode } ) =>
    {
        validateMode(mode, ModalMisWritebackInfoModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalMisWritebackInfoModes.VIEW:
                    setDialog ({ openState: true, mode: mode});
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);

        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( 'cancel' ) ;
        }
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalMisWritebackInfo onClose={onCloseModal}  mode={dialog.mode} onSaveComplete={onSaveComplete}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalMisWritebackInfo;